import { render, staticRenderFns } from "./WebMDDashboard.vue?vue&type=template&id=665e517f&scoped=true&"
import script from "./WebMDDashboard.vue?vue&type=script&lang=js&"
export * from "./WebMDDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WebMDDashboard.vue?vue&type=style&index=0&id=665e517f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e517f",
  null
  
)

export default component.exports